import Commons from '../../../Services/Common/Common';

/**
 * 작업중지 작성 (M_WOS_BASIC_01) 요청 파라미터 매핑
 * 사용처: M_WOS_BASIC_01_Query.js (useSearch1~3, useSave1, useSave2)
 */
export const WOS_BASIC_01_Schema = {
  /** 화면 폼 필드 정의 (initial, label, required, placeholder, maxLength) - createInitial / InputText schema 참조 */
  fields: {
    stopComment: {
      initial: '',
      label: '내용',
      required: 'Y',
      placeholder: '내용을 입력하세요.',
      maxLength: 1000,
    },
  },

  mapper: {
    /** useSearch1 → GetWosBasic01R1 (사업장 조회) SP_GET_AUTH_CUST_MANAGER */
    search1: {
      UserId: (context) => context.userInfo?.userid ?? '',
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd) || '',
    },
    /** useSearch2 → GetWosBasic01R2 (부서 조회) SP_GET_DEP_LAST */
    search2: {
      CustCd: (context) => Commons.EncryptAES(context.custCd ?? '') || '',
    },
    /** useSearch3 → GetWosBasic01R3 (부서 인원 조회) SP_GET_DEP_MEMBER */
    search3: {
      DepCd: (context) => {
        return Commons.EncryptAES(context.depCdList.join(','));
      },
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
    },
    /** useSearch4 → GetWosBasic01R4 (동일부서 결재권자 + 동일사업장 안전관리자) SaveLogic3용 */
    search4: {
      UserId: (context) => context.userInfo?.userid ?? '',
    },
    search5: {
      AuthCd: (context) =>
        Commons.EncryptAES(context.userInfo?.authCd || '') || '',
      CoCd: (context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd || ''
        ) || '',
      CustCd: (context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      SearchText: (context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },
    /** useSave1 → SaveWosBasicU1 (작업중지 등록) SP_WOS_BASIC_U1 */
    save1: {
      WorkStopCd: (ctx) => Commons.EncryptAES(ctx?.workStopCd ?? '') || '',
      DepCd: (ctx) => Commons.EncryptAES(ctx?.depCd ?? '') || '',
      StopAuth: (ctx) => Commons.EncryptAES(ctx?.stopAuth ?? '') || '',
      StopComment: (ctx) => Commons.EncryptAES(ctx?.stopComment ?? '') || '',
      StopImagePath: (ctx) =>
        Commons.EncryptAES(ctx?.stopImagePath ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
    /** useSave2 → SaveWosBasicU3 (작업중지 멤버 저장) SP_WOS_BASIC_U3 */
    save2: {
      WorkStopCd: (ctx) => Commons.EncryptAES(ctx?.workStopCd ?? '') || '',
      StopId: (ctx) => Commons.EncryptAES(ctx?.stopId ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
  },
};
